<script>
import ButtonForm from './ButtonForm.vue';
import ListForm from './ListForm.vue';
import LocationForm from './LocationForm.vue';
import PollForm from './PollForm.vue';
import StickerForm from './StickerForm.vue';
import CarouselForm from './CarouselForm.vue';
import LinkForm from './LinkForm.vue';

const FORM_BY_TYPE = {
  button: 'ButtonForm',
  list: 'ListForm',
  location: 'LocationForm',
  poll: 'PollForm',
  sticker: 'StickerForm',
  carousel: 'CarouselForm',
  link: 'LinkForm',
};

export default {
  components: {
    ButtonForm,
    ListForm,
    LocationForm,
    PollForm,
    StickerForm,
    CarouselForm,
    LinkForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: null,
    },
  },
  emits: ['onSend', 'cancel', 'update:show'],
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    formComponent() {
      return FORM_BY_TYPE[this.type] || null;
    },
    modalTitle() {
      const key = (this.type || '').toUpperCase();
      return this.$t(`CONVERSATION.EVOLUTION_INTERACTIVE.MODAL_TITLE.${key}`);
    },
  },
  methods: {
    onSendMessage(message) {
      this.$emit('onSend', message);
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <woot-modal v-model:show="localShow" :on-close="onClose" size="modal-big">
    <woot-modal-header :header-title="modalTitle" />
    <div class="modal-content">
      <component
        :is="formComponent"
        v-if="formComponent"
        @send-message="onSendMessage"
        @cancel="onClose"
      />
    </div>
  </woot-modal>
</template>

<style scoped>
.modal-content {
  padding: 1.5625rem 2rem;
}
</style>
